
import { Component, Vue } from 'vue-property-decorator';

@Component<UnitRepresentativePage>({})
export default class UnitRepresentativePage extends Vue {}
